/**
 * No Data State Component
 * Displays message when no portfolio management data is available
 */

import React from "react";

interface NoDataStateProps {
	message?: string;
	onRefresh?: () => void;
}

const NoDataState: React.FC<NoDataStateProps> = ({
	message = "No portfolio management data available",
	onRefresh,
}) => {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				height: "100vh",
				fontFamily: '"Inter", "Inter Display"',
				color: "#6B7280",
				gap: "16px",
			}}
		>
			<div>{message}</div>
			{onRefresh && (
				<button
					onClick={onRefresh}
					style={{
						padding: "8px 16px",
						backgroundColor: "#004C4B",
						color: "white",
						border: "none",
						borderRadius: "6px",
						cursor: "pointer",
						fontFamily: '"Inter", "Inter Display"',
						fontSize: "14px",
					}}
				>
					Refresh
				</button>
			)}
		</div>
	);
};

export default NoDataState;
